export class Guest {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.sequence = params.sequence ? params.sequence : null
    this.bookingId = params.booking_id ? params.booking_id : null
    this.type = params.type ? params.type : params.type_id
    this.typeId = params.type_id ? params.type_id : null
    this.room = params.room ? params.room : params.room_id
    this.roomId = params.room_id ? params.room_id : null
    this.checkin = params.checkin ? params.checkin : null
    this.checkout = params.checkout ? params.checkout : null
    this.checkoutMoment = params.checkout_moment ? params.checkout_moment : null
    this.profile = params.profile ? params.profile : params.profile_id
    this.profileId = params.profile_id ? params.profile_id : null
    this.account = params.account ? params.account : params.account_id
    this.accountId = params.account_id ? params.account_id : null
    this.dietRestrictions = params.diet_restrictions ? params.diet_restrictions : null
    this.editable = params.editable ? params.editable : false
    this.active = params.active ? params.active : false
  }
}
